import { SET_PATHWAYU_INTEGRATION, INTEGRATION_SUCCESS } from './actions';

const initialState = {
  hubs: [],
  companies: [],
  loading: false,
  companiesLoading: false,
  error: null,
  integrationLoading: false,
  success: false,
};

const pathwayuIntegrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PATHWAYU_INTEGRATION:
      return {
        ...state,
        ...action.data,
      };

    case INTEGRATION_SUCCESS:
      return {
        ...state,
        success: true,
      };

    default:
      return state;
  }
};

export default pathwayuIntegrationReducer;
